import { render, staticRenderFns } from "./keyHome.vue?vue&type=template&id=dccabbb2&scoped=true&"
import script from "./keyHome.vue?vue&type=script&lang=js&"
export * from "./keyHome.vue?vue&type=script&lang=js&"
import style0 from "./keyHome.vue?vue&type=style&index=0&id=dccabbb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccabbb2",
  null
  
)

export default component.exports